module.exports = __webpack_public_path__ + "static/media/notifications.466d9bee.svg";